<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" :fill="colour" :stroke="colour" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-circle"><circle cx="12" cy="12" r="10"></circle></svg>
</template>

<script>
export default {
  props: ['colour']
}
</script>



// WEBPACK FOOTER //
// src/components/IconCircle.vue